import { ArrowDown } from 'lucide-react';

const WHATSAPP_NUMBER = '5575981872440';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá, vim do site de nódulo e gostaria de agendar uma consulta com dr. Mateus')}`;

const badges = [
  '500+ Procedimentos',
  'Acompanhamento Multidisciplinar',
  'Cuidado Humanizado',
];

export default function NoduloHero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden"
      style={{
        backgroundImage: 'url(/images/hospital_bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top'
      }}
    >
      <div className="absolute inset-0 bg-white/60 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 lg:px-8 w-full py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center bg-[#0D47A1]/8 border border-[#0D47A1]/20 rounded-full px-4 py-1.5 text-sm font-semibold text-[#0D47A1] mb-6">
              Cirurgião Torácico · Feira de Santana, BA
            </div>

            <h1 className="font-poppins font-bold text-4xl sm:text-5xl lg:text-5xl tracking-tight leading-tight mb-4 text-[#0D47A1]">
              Descobriu um Nódulo Pulmonar?<br />
              <span className="text-[#00897B]">O Especialista Que Você Precisa Está Aqui</span>
            </h1>

            <p className="text-lg md:text-xl text-[#212121]/80 mb-5 font-semibold leading-snug">
              Diagnóstico preciso, acompanhamento seguro e tratamento adequado. Você não está sozinho nessa jornada.
            </p>

            <p className="text-base md:text-lg text-[#212121]/60 mb-8 leading-relaxed max-w-lg">
              Um nódulo pulmonar no exame assusta e você logo pensa no pior. Mas a verdade é que nem todo
              nódulo é maligno. Muitos são definitivamente benignos, outros precisam apenas de acompanhamento
              periódico e alguns realmente necessitam de intervenção — que o Cirurgião Torácico está
              capacitado a realizar com precisão. O que você precisa agora é de um especialista que entenda
              de nódulos. Você o encontrou aqui.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#0D47A1] text-white font-poppins font-bold px-8 py-4 rounded-full hover:bg-[#00897B] transition-all duration-200 text-center shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                QUERO AVALIAR O MEU NÓDULO
              </a>
              <a
                href="#oque-fazer"
                className="text-[#0D47A1] border-2 border-[#0D47A1]/30 font-poppins font-semibold px-8 py-4 rounded-full hover:bg-[#0D47A1]/8 hover:border-[#0D47A1]/60 transition-all duration-200 text-center flex items-center justify-center gap-2"
              >
                Como funciona o diagnóstico
                <ArrowDown size={16} />
              </a>
            </div>

            <div className="flex flex-wrap gap-2 pt-8 border-t border-[#0D47A1]/15">
              {badges.map((badge) => (
                <span
                  key={badge}
                  className="inline-flex items-center bg-[#0D47A1] text-white rounded-full px-4 py-2 text-sm font-semibold"
                >
                  {badge}
                </span>
              ))}
            </div>
          </div>

          <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-end">
            <div className="relative w-full max-w-sm lg:max-w-xl flex flex-col items-center">
              <img
                src="/images/nodulo_hero_photo.jpg"
                alt="Dr. Mateus Marques - Cirurgião Torácico especialista em Nódulo Pulmonar"
                className="w-full h-auto object-contain"
                style={{ maxHeight: '700px', borderRadius: '24px', boxShadow: '0 20px 60px rgba(13,71,161,0.15)' }}
                loading="eager"
                fetchpriority="high"
                decoding="sync"
              />
              <div className="absolute top-6 -right-2 bg-[#00897B] rounded-2xl p-4 shadow-xl">
                <div className="font-poppins font-bold text-2xl text-white">500+</div>
                <div className="text-white/80 text-xs font-medium">procedimentos</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
